/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* global window */
/* eslint-disable object-curly-newline */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import InfoPopupModern from 'components/InfoPopup/InfoPopupModern';
import withTranslate from 'react-redux-multilingual/lib/withTranslate';
import './AnalystsConsensus.scss';
import Guid from 'Utils/guid';
import DoughnutChart from 'components/DoughnutChart/DoughnutChart';
import { get } from 'lodash';
import { requestTipRanksBySymbol } from 'Actions/TipranksActions';

const AnalystsConsensus = props => {
	const {
		translate,
		xids,
		symbol,
		country
	} = props;
	const dispatch = useDispatch();

	const [tipranksData, setTipranksData] = useState();
	const [percentObj, setPercentageObj] = useState({ buy: 0, hold: 0, sell: 0 });

	useEffect(() => {
		dispatch(requestTipRanksBySymbol(
			country.toUpperCase() !== 'CA' ? symbol : `TSE:${symbol}`,
			result => setTipranksData(get(result, 'data.tipranksResult.0'))
		));
	}, [symbol, country]);

	useEffect(() => {
		if (tipranksData) {
			const total = tipranksData.buy + tipranksData.hold + tipranksData.sell;
			const buyPercent = Number.isNaN(Math.round((tipranksData.buy * 100) / total)) ? 0 : Math.round((tipranksData.buy * 100) / total);
			const holdPercent = Number.isNaN(Math.round((tipranksData.hold * 100) / total)) ? 0 : Math.round((tipranksData.hold * 100) / total);
			const sellPercent = Number.isNaN(Math.round((tipranksData.sell * 100) / total)) ? 0 : Math.round((tipranksData.sell * 100) / total);
			setPercentageObj({ buy: buyPercent, hold: holdPercent, sell: sellPercent });
		} else {
			setPercentageObj({ buy: 0, hold: 0, sell: 0 });
		}
	}, [tipranksData]);

	const dataProps = [
		{
			name: translate('accountHoldings.buy'),
			value: get(tipranksData, 'buy', 0) || 0,
			color: '#0A6D42'
		},
		{
			name: translate('accountHoldings.hold'),
			value: get(tipranksData, 'hold', 0) || 0,
			color: '#76B297'
		},
		{
			name: translate('accountHoldings.sell'),
			value: get(tipranksData, 'sell', 0) || 0,
			color: '#994E04'
		}
	];
	const highestPercentageObj = dataProps.find(item => Math.max(item.value)) || dataProps[0];

	return (
		<div className="analyst-consensus">
			<div className="title">
				{translate('analystConsensus')}
				<InfoPopupModern size="small">
					{translate('analystConsensusTooltip')}
				</InfoPopupModern>

				<span className="more-link">
					<a
						role="link"
						tabIndex="0"
						onKeyDown={event => {
							if (event.keyCode === 13) {
								window.mdPageActions.navigateOBR('analyst-ratings', { market: country, symbol });
							}
						}}
						onClick={() => {
							window.mdPageActions.navigateOBR('analyst-ratings', { market: country, symbol });
						}}>
						{translate('more')}
					</a>
				</span>

			</div>

			<div>
				{
					(tipranksData && (percentObj.buy !== 0 || percentObj.hold !== 0 || percentObj.sell !== 0))
						? (
							<div style={{ display: 'inline-flex' }}>
								<DoughnutChart
									height={102}
									width={104}
									outerRadius={46}
									innerRadius={29}
									includeLabel={false}
									key={Guid.getNewGuid()}
									data={dataProps || []} />
								<div style={{ marginLeft: '13px' }} className="chartData">
									<div className="highestPercentLabel">
										<h4>
											{highestPercentageObj.name}
										</h4>

									</div>
									<div className="chartDataInfo" style={{ display: 'inline-flex' }}>
										<div className="color-box" style={{ backgroundColor: '#0A6D42' }} />
										<span className="title">
											<p>
												{dataProps[0].name}
											&nbsp;
												{percentObj.buy}
												%
											</p>
										</span>

									</div>
									<div className="chartDataInfo" style={{ display: 'inline-flex' }}>
										<div className="color-box" style={{ backgroundColor: '#76B297' }} />
										<span className="title">
											<p>
												{dataProps[1].name}
											&nbsp;
												{percentObj.hold}
												%
											</p>
										</span>
									</div>

									<div style={{ display: 'inline-flex' }}>
										<div className="color-box" style={{ backgroundColor: '#B73A18' }} />
										<span className="title">
											<p>
												{dataProps[2].name}
									&nbsp;
												{percentObj.sell}
												%
											</p>
										</span>
									</div>
								</div>
							</div>
						)
						: <div className="noDataAvailable"><p>{`${translate('noDataAvailable')}`}</p></div>
				}
			</div>
		</div>
	);
};

export default withTranslate(AnalystsConsensus);
